import as1141_11_1 from './As/1141_11_1/Config';
import as1289_3_6_1 from './As/1289_3_6_1/Config';
import astmC117 from './Astm/C117/Config';
import astmD1140 from './Astm/D1140/Config';
import astmD6913 from './Astm/D6913/Config';
import bsen from './BsEn/Config';
import bseniso from './BsEnIso/Config';

export default {
  ...astmC117,
  ...astmD1140,
  ...astmD6913,
  ...bsen,
  ...bseniso,
  ...as1141_11_1,
  ...as1289_3_6_1,
};
